// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"2faf13e7","544":"5b5851d6","555":"972779d5","572":"d3c907a8","594":"b7cdcef7","720":"8da272f0","818":"3dedb016"}[chunkId] + ".chunk.js";
};